import { useState, useEffect } from 'react'
import { ChatbotConfigurationConversationsAction, ChatbotConfigurationKnowledgeAction } from '../../actions'
import { useTranslation } from 'react-i18next'
import { Container, Grid } from '@material-ui/core'
import { TabPure, SimpleLoading } from '../../pures'
import { ChatbotService } from '../../../services'
import { ModalUtil } from '../../pures'
import { useGlobalState } from '../../../GlobalState'

const ChatbotConfigurationConversation = () => {
  const { t } = useTranslation()
  const { t: transl, i18n, ready } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig' })
  const url = process.env.REACT_APP_ETICKET_API
  const chatbotService = new ChatbotService(url)
  const modalUtil = new ModalUtil()
  const { botConfig } = useGlobalState()

  const [loading, setLoading] = useState(true)
  const [botId, setBotId] = useState()
  const [conversations, setConversations] = useState([])
  const [files, setFiles] = useState([])

  const [tabSelected, setTabSelected] = useState('knowledge')

  const tabs = [
    {
      route: 'knowledge',
      title: transl('knowledge.title'),
      key: 'knowledge.title',
      selected: (tabSelected === 'knowledge') ? true : false
    },
    {
      route: 'conversations',
      title: transl('conversations.title'),
      key: 'conversations.title',
      selected: (tabSelected === 'conversations') ? true : false
    }
  ]

  const updateTabStatus = (tabSelected) => {
    setTabSelected(tabSelected)
  }

  const getConversations = async () => {
    try {
      setLoading(true)
      const data = await chatbotService.getConversations(botConfig?.id)
      setBotId(data.id)
      setConversations(data.conversations)
      setLoading(false)
    } catch (error) {
      modalUtil.showModal('error', error.message, t('modal.pure.title.error'))
    }
  }

  const getFiles = async () => {
    setLoading(true)
    try {
      const data = await chatbotService.getKnowledgeFiles(botConfig?.id);
      setFiles(data)
      setLoading(false)
    } catch (error) {
      modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
    }
  }

  const handleLoadConversations = () => {
    if (botConfig?.id) {
      getConversations()
      getFiles()
    }
  }

  useEffect(() => {
    handleLoadConversations()
  }, [botConfig])

  if (loading) return <div className='loading'>
    <SimpleLoading />
  </div>

  return (
    ready &&
    <>
      <Container className='view-container'>
        <Grid container spacing={3}>
          <TabPure tabs={tabs} tabStatus={updateTabStatus} language={i18n.language} transl={transl} />

          <Grid item xs={12}>
            <Container maxWidth={'md'}>
              <Grid container spacing={2}>
                {
                  tabSelected === 'conversations' && (
                    <ChatbotConfigurationConversationsAction botId={botId} conversations={conversations} setConversations={setConversations} loading={loading} setLoading={setLoading} />
                  )
                }
                {
                  tabSelected === 'knowledge' && (
                    <ChatbotConfigurationKnowledgeAction files={files} setFiles={setFiles} loading={loading} setLoading={setLoading} />
                  )
                }
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default ChatbotConfigurationConversation